import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthModalProvider } from './contexts/AuthModalContext';
import { QuickViewProvider } from './contexts/QuickViewContext';
import Layout from './components/layout/Layout';
import HomePage from './components/pages/HomePage';
import ProductsPage from './components/product/ProductsPage';
import ProductDetailsPage from './components/product/ProductDetailsPage';
import CartPage from './components/cart/CartPage';
import CheckoutPage from './components/checkout/CheckoutPage';
import SuccessPage from './components/checkout/SuccessPage';
import AdminLoginPage from './components/admin/AdminLoginPage';
import AdminPage from './components/admin/AdminPage';
import AccountPage from './components/pages/AccountPage';
import AboutUsPage from './components/pages/AboutUsPage';
import AccountConfirmed from './components/pages/AccountConfirmed';
import OrdersPage from './components/order/OrdersPage';
import OrderDetailsPage from './components/order/OrderDetailsPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import ChatbotWidget from './components/ui/ChatbotWidget';
import AdminRoute from './components/auth/AdminRoute';
import ForgotPasswordPage from './components/auth/ForgotPasswordPage';
import ResetPasswordPage from './components/auth/ResetPasswordPage';
import ConfirmationPage from './components/checkout/ConfirmationPage';
import ScrollToTop from './components/utils/ScrollToTop';
import PrivacyPolicyPage from './components/pages/PrivacyPolicyPage';
import TermsOfUsePage from './components/pages/TermsOfUsePage';
import FaqPage from './components/pages/FaqPage';
import HowToBuyPage from './components/pages/HowToBuyPage';
import ShippingPage from './components/pages/ShippingPage';
import './styles/global.css';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <ThemeProvider>
          <AuthModalProvider>
            <QuickViewProvider>
              <ScrollToTop />
              <Routes>
                {/* ========== ROTAS ADMIN (SEM LAYOUT) ========== */}
                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route path="/admin" element={
                  <AdminRoute>
                    <AdminPage />
                  </AdminRoute>
                } />
                
                {/* ========== ROTAS COM LAYOUT ========== */}
                <Route path="/*" element={
                  <Layout>
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/quem-somos" element={<AboutUsPage />} />
                      <Route path="/politica-de-privacidade" element={<PrivacyPolicyPage />} />
                      <Route path="/termos-de-uso" element={<TermsOfUsePage />} />
                      <Route path="/faq" element={<FaqPage />} />
                      <Route path="/como-comprar" element={<HowToBuyPage />} />
                      <Route path="/envio-e-entrega" element={<ShippingPage />} />
                      <Route path="/catalogo/:category?" element={<ProductsPage />} />
                      <Route path="/produto/:id" element={<ProductDetailsPage />} />
                      <Route path="/carrinho" element={<CartPage />} />
                      <Route path="/checkout" element={
                        <ProtectedRoute>
                          <CheckoutPage />
                        </ProtectedRoute>
                      } />
                      <Route path="/success" element={<SuccessPage />} />
                      <Route path="/account" element={
                        <ProtectedRoute>
                          <AccountPage />
                        </ProtectedRoute>
                      } />
                      <Route path="/account-confirmed" element={<AccountConfirmed />} />
                      <Route path="/orders" element={
                        <ProtectedRoute>
                          <OrdersPage />
                        </ProtectedRoute>
                      } />
                      <Route path="/orders/:id" element={
                        <ProtectedRoute>
                          <OrderDetailsPage />
                        </ProtectedRoute>
                      } />
                      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
                      <Route path="/confirm-account/:token" element={<ConfirmationPage />} />
                    </Routes>
                    <ChatbotWidget />
                  </Layout>
                } />
              </Routes>
            </QuickViewProvider>
          </AuthModalProvider>
        </ThemeProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;